export const withRetries = (cb: () => Promise<any>, errorCB: () => any) => {
  return () => {
    let promise = cb();
    for (let i = 0; i < 2; i += 1) {
      promise = promise.catch(() => {
        return cb();
      });
    }
    return promise.catch(errorCB);
  };
};
